export const formIdRegister = 'ba0596ce-82dd-4f60-8423-73dbef7b807b'

export const field = [
  {
    fieldName: 'document',
    fieldValue: 'pii filtered',
    fieldLabel: 'CPF ou CNPJ',
    fieldType: 'DOCUMENT',
  },
  {
    fieldName: 'name',
    fieldValue: 'pii filtered',
    fieldLabel: 'Nome completo',
    fieldType: 'FULLNAME',
  },
  {
    fieldName: 'email',
    fieldValue: 'pii filtered',
    fieldLabel: 'E-mail',
    fieldType: 'EMAIL',
  },
  {
    fieldName: 'birth_date',
    fieldValue: 'pii filtered',
    fieldLabel: 'Data de nascimento',
    fieldType: 'DOB',
  },
  {
    fieldName: 'cellphone',
    fieldValue: 'pii filtered',
    fieldLabel: 'Celular',
    fieldType: 'CONTACT',
  },
]
